var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define("SuiteCommerce.Blog.Post.Footer.View", ["require", "exports", "Backbone", "sc_blog_post_footer.tpl", "SuiteCommerce.Blog.Common", "SuiteCommerce.Blog.Post.Category.View"], function (require, exports, Backbone_1, footerTemplate, Common_1, Post_Category_View_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.PostFooterView = void 0;
    var PostFooterView = /** @class */ (function (_super) {
        __extends(PostFooterView, _super);
        function PostFooterView() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.template = footerTemplate;
            return _this;
        }
        Object.defineProperty(PostFooterView.prototype, "childViews", {
            get: function () {
                var _this = this;
                return {
                    'Category.View': function () {
                        return new Post_Category_View_1.PostCategoryView({ model: _this.model });
                    },
                };
            },
            enumerable: false,
            configurable: true
        });
        PostFooterView.prototype.getContext = function () {
            return {
                showTags: this.model.tags.length > 0,
                tags: this.model.tags,
                tagURL: Common_1.BLOG_URL_BASE + "/" + Common_1.AvailableTaxonomies.tag + "/",
            };
        };
        return PostFooterView;
    }(Backbone_1.View));
    exports.PostFooterView = PostFooterView;
});
